import { clsx } from "clsx";
import type { ReactNode } from "react";

type Tone = "good" | "ok" | "warn" | "bad" | "muted" | "accent";

const TONE_CLASSES: Record<Tone, string> = {
  good: "bg-success-subtle text-success border-success/20",
  ok: "bg-surface-subtle text-foreground-secondary border-border-subtle",
  warn: "bg-warning-subtle text-warning border-warning/20",
  bad: "bg-danger-subtle text-danger border-danger/20",
  muted: "bg-surface-base text-foreground-muted border-border-subtle",
  accent: "bg-accent-subtle text-accent-strong border-accent/20",
};

type PillProps = {
  tone?: Tone;
  className?: string;
  children: ReactNode;
};

export function Pill({ tone = "ok", className, children }: PillProps) {
  return (
    <span
      className={clsx(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-2xs font-medium uppercase tracking-wider",
        TONE_CLASSES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
